/// <amd-module name="Artifacts/Root/components/PromoteModal" />
import { CommandPanel } from "Artifacts/Root/components/CommandPanel";
import { ComponentState } from "Artifacts/Root/Constants";
import { registerModal } from "Artifacts/Root/containers/ModalManager";
import { useFeed } from "Artifacts/Root/hooks/FeedUrlResolver";
import { connectDynamicModules } from "Artifacts/Root/redux";
import { IRootModuleState } from "Artifacts/Root/redux/Contracts";
import { RootModule } from "Artifacts/Root/redux/Module";
import * as Res from "Artifacts/Root/Resources";
import { IPackageVersionIdentity } from "Artifacts/Root/types";
import { ViewIdentifier } from "Artifacts/Root/types/AzureArtifacts";
import { FeedViewType } from "Artifacts/Root/web-apis/contracts/Feed";
import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { Dropdown } from "VSSUI/Dropdown";
import { IListSelection } from "VSSUI/List";
import { DropdownSelection } from "VSSUI/Utilities/DropdownSelection";

export interface IPromoteModalProps {
  packages?: IPackageVersionIdentity[];
  onDismiss: () => void;
  onPromote: (view: string) => () => void;
}

interface IMapStateToProps {
  componentState: ComponentState;
}

export const PromoteModalId = "PromoteModal";

const PromoteModal: React.FC<IPromoteModalProps & IMapStateToProps> = ({
  packages,
  onDismiss,
  onPromote,
  componentState,
}) => {
  const { feed } = useFeed();

  const feedViews: ViewIdentifier[] = feed?.views || [];

  const packageViews = getIntersectionOfViews(packages || []);

  const viewItems = feedViews
    .filter((view) => packageViews.indexOf(view.name) < 0)
    .filter((view) => view.type !== FeedViewType.Implicit)
    .map((view) => {
      return {
        id: view.id,
        text: `${feed?.name}@${view.name}`,
      };
    });

  const [selectedView, setSelectedView] = useState<string>(viewItems[0]?.id);
  const [selection] = useState<IListSelection>(() => new DropdownSelection());

  return (
    <CommandPanel
      title={Res.PromotePackageDialogTitle}
      description={
        viewItems.length >= 1
          ? Res.PromotePackageDialogDescription
          : Res.PromotePackageDialogContent_NoMoreViews
      }
      packages={packages}
      onDismiss={onDismiss}
      onSubmit={onPromote(selectedView)}
      submitButtonComponentState={componentState}
      submitButtonText={Res.PromoteCommandButton}
      isSubmitButtonDisabled={selectedView == null}
    >
      {
        <div>
          {viewItems.length < 1 ? (
            <span></span>
          ) : (
            <Dropdown
              items={viewItems}
              selection={selection}
              onSelect={(_event, item) => {
                setSelectedView(item.id);
              }}
              placeholder={Res.ViewDropdownPlaceholder}
            />
          )}
        </div>
      }
    </CommandPanel>
  );
};

function getIntersectionOfViews(packages: IPackageVersionIdentity[]): string[] {
  // TODO: this can be done more concisely with Sets.
  // intersect can be simulated via const intersection = new Set([...mySet1].filter(x => mySet2.has(x)))

  const sharedViews: string[] = [];
  const counts: Record<string, number> = {};

  packages.forEach((p) => {
    p.views.forEach((v) => {
      counts[v] = (counts[v] || 0) + 1;
    });
  });

  for (const viewName in counts) {
    if (counts[viewName] === packages.length) {
      sharedViews.push(viewName);
    }
  }

  return sharedViews;
}

const mapStateToProps = (state: IRootModuleState): IMapStateToProps => {
  const rootState = state.rootState;
  return {
    componentState: rootState.promoteCommandState,
  };
};

const ConnectedPromoteModal = connectDynamicModules(connect(mapStateToProps)(PromoteModal), [
  RootModule,
]);

registerModal(PromoteModalId, ConnectedPromoteModal);

export { PromoteModal };
